import Routes from './routes'
import AccountReducer from './store/account'
import ReducerFuncs from './store'
import ComplianceReducer from './components/compliance/store'

const Reducers = reducerObj => {
  reducerObj.account = AccountReducer
  reducerObj.crm = ReducerFuncs
  reducerObj.compliance = ComplianceReducer
}

export default Reducers

export { Routes, Reducers }
